import axios from 'axios'
import config from '../config/index'

// import { MessageBox, Message } from 'element-ui'
// import store from '@/store'
// import { getToken } from '@/utils/auth'

// create an axios instance
const service = axios.create({
    baseURL: config.apiHttpsUrl,
    timeout: 6000000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        return config
    },
    error => {
        console.log(error) // for debug
    }
)

// response interceptor
service.interceptors.response.use(
    response => {
        const res = response.data
            return response
    },
    error => {
        console.log('err' + error) // for debug
    }
)

export default service
